interface ProfileNumberSources {
  eManifestProfileNumber?: string | null;
  vendorProfileNumber?: string | null;
}

export function formatWasteStreamProfileNumber(sources: ProfileNumberSources): string {
  const eManifestProfileNumber = sources.eManifestProfileNumber;
  const vendorProfileNumber = sources.vendorProfileNumber;

  if (
    eManifestProfileNumber &&
    vendorProfileNumber &&
    vendorProfileNumber !== eManifestProfileNumber
  ) {
    // Use " | " between sides — each side may itself be a comma-joined list of
    // distinct values (from SQL STRING_AGG), so a comma separator would be ambiguous.
    return `Vendor: ${vendorProfileNumber} | e‑Manifest: ${eManifestProfileNumber}`;
  } else if (eManifestProfileNumber) {
    return eManifestProfileNumber;
  } else if (vendorProfileNumber) {
    return vendorProfileNumber;
  } else {
    return "";
  }
}

export function profileNumberValueGetter(_: unknown, row: ProfileNumberSources) {
  return formatWasteStreamProfileNumber(row);
}
